import { render, staticRenderFns } from "./siderOrderFilter.vue?vue&type=template&id=1a7f5628&"
import script from "./siderOrderFilter.vue?vue&type=script&lang=js&"
export * from "./siderOrderFilter.vue?vue&type=script&lang=js&"
import style0 from "./siderOrderFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports